import { signIn } from 'next-auth/react';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export default function useHomeHook() {
  const searchParams = useSearchParams();
  const tokenUsuario = searchParams.get('data');

  async function logarUsuarioToken() {
    localStorage.setItem('chippuPlace@AcessoAPPChippu', 'true');
    await signIn('token', {
      redirect: true,
      accessToken: tokenUsuario,
      callbackUrl: '/',
    });
  }

  useEffect(() => {
    if (!tokenUsuario) return;
    logarUsuarioToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenUsuario]);

  return;
}
